export default "__VITE_ASSET__CwS9XSJy__"